/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { variationsListGroups } from "../funcs/variationsListGroups.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolVariationGroupsResult } from "../models/components/listtoolvariationgroupsresult.js";
import {
  ListToolVariationGroupsRequest,
  ListToolVariationGroupsSecurity,
} from "../models/operations/listtoolvariationgroups.js";
import { unwrapAsync } from "../types/fp.js";
export type ToolVariationGroupsQueryData = ListToolVariationGroupsResult;

export function prefetchToolVariationGroups(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListToolVariationGroupsRequest | undefined,
  security?: ListToolVariationGroupsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildToolVariationGroupsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildToolVariationGroupsQuery(
  client$: GramCore,
  request?: ListToolVariationGroupsRequest | undefined,
  security?: ListToolVariationGroupsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ToolVariationGroupsQueryData>;
} {
  return {
    queryKey: queryKeyToolVariationGroups({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function toolVariationGroupsQueryFn(
      ctx,
    ): Promise<ToolVariationGroupsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(variationsListGroups(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyToolVariationGroups(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "variations", "listGroups", parameters];
}
